import { MouseEventHandler, ReactNode } from 'react';
import { cn } from '../../utils';

type IconButtonProps = {
    className?: string | object;
    children?: ReactNode;
    disabled?: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
    type?: 'button' | 'submit' | 'reset';
};

export default function IconButton({
    className = '',
    children,
    onClick,
    disabled = false,
    type = 'button',
    ...rest
}: IconButtonProps) {
    return (
        <>
            <button
                {...rest}
                type={type}
                disabled={disabled}
                className={cn(
                    {
                        [css.disabled]: disabled,
                        [css.enabled]: !disabled,
                    },
                    className,
                )}
                onClick={onClick}>
                {children}
            </button>
        </>
    );
}

export const css = {
    disabled:
        'alli-cursor-not-allowed alli-text-gray-600 focus-visible:alli-outline-none alli-p-1.5 alli-rounded-full',
    enabled:
        'alli-rounded-full alli-p-1.5 alli-text-gray-750 alli-opacity-70 hover:alli-text-gray-750 hover:alli-opacity-100 focus-visible:alli-text-blue-gray-700 focus-visible:alli-opacity-100 focus-visible:alli-outline-2 focus-visible:alli-outline-offset-2 focus-visible:alli-outline-blue-600 active:alli-text-blue-gray-700',
};
